<div class="ticket-drawer" [formGroup]="ticketForm">
  <div class="ticket-drawer-layout">
    <!-- LEFT: SIDEBAR (256px, collapsible) -->
    <app-ticket-sidebar [ticketForm]="ticketForm" [projectName]="getProjectName()" [ticketId]="ticketID || 'New'"
      [ticketCode]="model?.code" [mode]="ticketID ? 'edit' : 'create'" [modules]="modulesList" [milestones]="milestones"
      [statuses]="statuses" [ticketTypes]="ticketTypesList" [scopes]="scopes" [customers]="customers"
      [vendors]="vendors" [subcontractors]="subcontractor" [contacts]="contacts"
      [selectedResponsibleParty]="selectedResponsibleParty" [selectedMilestone]="getSelectedMilestone()"
      [assignees]="responsibleUsersArray" [observers]="observerArray" [participants]="participantArray"
      [savedDefaults]="savedDefaults"
      [tags]="ticketTags" [completionPercentage]="completionPercentage"
      [checklist]="ticketForm.get('checklists')?.value || []" [createdOn]="model?.created_at"
      [isCollapsed]="isSidebarCollapsed" (onCollapse)="onSidebarCollapse($any($event))"
      (onSearch)="handleSearch($any($event))" (fieldChange)="handleFieldChange($any($event))"
      (statusChange)="handleStatusChange($any($event))" (moduleSelected)="selectedModule($any($event))"
      (referenceSelected)="onItemSelect($any($event))" (selfAssignChange)="handleSelfAssignChange($any($event))"
      (milestoneSelected)="handleMilestoneSelect($any($event))" (milestoneRemoved)="handleMilestoneRemove()"
      (assigneeSelectorOpened)="openUsersPopup($any($event), CONST_RESPONSIBLE_PERSON_TYPE)"
      (assigneeSelected)="handleAssigneeSelected($any($event))" (assigneeRemoved)="removeAssignee($any($event))"
      (defaultAssigneeChanged)="handleDefaultAssigneeChanged($any($event))"
      (observerSelectorOpened)="openUsersPopup($any($event), CONST_OBSERVER_TYPE)"
      (observerSelected)="handleObserverSelected($any($event))" (observerRemoved)="removeObserver($any($event))"
      (defaultObserverChanged)="handleDefaultObserverChanged($any($event))"
      (participantSelectorOpened)="openUsersPopup($any($event), CONST_PARTICIPANT_TYPE)"
      (participantSelected)="handleParticipantSelected($any($event))"
      (defaultParticipantChanged)="handleDefaultParticipantChanged($any($event))"
      (participantRemoved)="removeParticipant($any($event))" (timePlanningToggle)="hideShowTimePlanning()"
      (tagSelectorOpened)="openTagSelector()" (tagRemoved)="removeTagByIndex($any($event))"
      (tagsUpdated)="handleTagsUpdated($any($event))" (startDateChange)="handleStartDateChange($any($event))"
      (durationChange)="handleDurationChange($any($event))" (finishDateChange)="handleFinishDateChange($any($event))"
      (customerSelected)="getCustomerContacts($any($event))" (vendorSelected)="setVendor($any($event))"
      (subcontractorSelected)="setSubContractor($any($event))"
      (responsiblePartySelected)="setResponsibleParty($any($event))" [showModuleControls]="showModuleControls">
    </app-ticket-sidebar>

    <!-- RIGHT: MAIN CONTENT AREA -->
    <div class="ticket-main-area">
      <!-- HEADER -->
      <app-ticket-header [isEdit]="!!ticketID" [mode]="ticketID ? 'edit' : 'create'"
        [ticketTitle]="ticketForm.get('title')?.value" [moduleLabel]="getModuleLabel()" [projectName]="getProjectName()"
        [projectId]="getRecordNumber()" [recordRoute]="getRecordRoute()" [status]="getStatusFromForm()"
        [statusColor]="getSelectedStatus()?.color || '#6b7280'" [statuses]="statuses"
        [selectedStatus]="getSelectedStatus()" [milestone]="getSelectedMilestone()" [isFullscreen]="isFullscreen"
        [isFormValid]="ticketForm.valid" [searchQuery]="searchQuery" [templates]="templates"
        [hasTemplates]="templates && templates.length > 0" [isBillable]="isBillable"
        [isHighPriority]="CONST_HIGH_PRIORITY" [priority]="ticketForm.get('priority')?.value || 2" (save)="save()"
        (close)="close()" (recordLinkClick)="close()" (delete)="onConfirmation()" (searchToggle)="onHeaderSearchToggle($any($event))"
        (searchChange)="onHeaderSearchChange($any($event))" (fullscreenToggle)="onFullscreenToggle()"
        (billableToggle)="toggleBillable()" (priorityToggle)="changePriority()">
      </app-ticket-header>

      <!-- MAIN CONTENT WITH TABS -->
      <app-ticket-main-content [ticketForm]="ticketForm" [mode]="ticketID ? 'edit' : 'create'"
        [selectedMilestone]="getSelectedMilestone()" [checklistCount]="getChecklistCount()"
        [materialCount]="getMaterialsCount()" [attachmentCount]="getAttachmentsCount()" [commentCount]="ticketComments.length"
        [historyCount]="ticketHistory.length || 0" [activeTabIndex]="activeTabIndex" [isTicketModule]="isTicketModule"
        [modulesList]="modulesList" [searchParams]="searchParams" [selectedItem]="selectedItem"
        [showSearchInput]="showSearchInput" [mentions]="mentions" [isMentionsLoading]="isMentionsLoading"
        [hideDetailsCommentsHistory]="!ticketID" [showMaterials]="showMaterialsTab"
        (tabKeyChange)="handleTabKeyChange($any($event))" (tabChange)="handleTabChange($any($event))"
        (editDescription)="handleEditDescription()" (removeMilestone)="handleMilestoneRemove()"
        (moduleSelected)="selectedModule($any($event))" (itemSelected)="onItemSelect($any($event))"
        (itemCleared)="updateSearchInputFlag()" (mentionSelected)="getSelectedUser($any($event))"
        (mentionSearch)="getUsers($any($event))">

        <!-- DETAILS TAB CONTENT -->
        @if (ticketID) {
          <div details-tab>
            <app-ticket-details-tab [ticketForm]="ticketForm" [status]="getStatusFromForm()" [statuses]="statuses"
              [statusId]="ticketForm.get('status')?.value"
              [priority]="getPriorityText(ticketForm.get('priority')?.value || 2)"
              [dueDate]="ticketForm.get('due_date')?.value"
              [startDate]="ticketForm.get('start_date')?.value"
              [endDate]="ticketForm.get('date_finished')?.value"
              [assignee]="createdByArray?.full_name"
              [createdDate]="model?.created_at" [ticketType]="ticketForm.get('ticket_type_id')?.value?.name"
              [customer]="ticketForm.get('customer')?.value?.company_name"
              [vendor]="ticketForm.get('vendor')?.value?.name"
              [subcontractor]="ticketForm.get('subcontractor')?.value?.name"
              [responsibleParty]="selectedResponsibleParty?.name" [scopes]="getSelectedScopesForDisplay()">
            </app-ticket-details-tab>
          </div>
        }

        <!-- CHECKLIST TAB CONTENT -->
        <div checklist-tab>
          <div class="tab-content-wrapper">
            <app-ticket-checklist (callback)="getChecklists($event)" [checkLists]="model?.check_list" [model]="model"
              [ticketItems]="ticketForm.get('ticket_items')?.value" [showMaterials]="showMaterialsTab">
            </app-ticket-checklist>
          </div>
        </div>

        <!-- MATERIALS & SERVICES TAB CONTENT -->
        @if (showMaterialsTab) {
        <div materials-tab>
          <div class="tab-content-wrapper">
            <app-ticket-materials-services [materialServices]="model?.ticket_items"
              [jobId]="getTicketJobId()" [ticketId]="ticketID"
              (callback)="getMaterials($event)">
            </app-ticket-materials-services>
          </div>
        </div>
        }

        <!-- ATTACHMENTS TAB CONTENT -->
        <div attachments-tab>
          <div class="tab-content-wrapper">
            <!-- CREATE MODE: Use shared attachment component (no ticket ID yet) -->
            @if (!ticketID) {
              <app-attachment [dropZoneId]="'ticketAttachment'" [module_id]="TICKET_MODULE_ID"
                [multipleUpload]="true" [allowAllFileTypes]="true" (callback)="getFileID($event)"
                (onDelete)="handleAttachmentDelete($event)">
              </app-attachment>
            }

            <!-- EDIT MODE: Use ticket-attachments component (ticket exists) -->
            @if (ticketID) {
              <app-ticket-attachments [module_id]="TICKET_MODULE_ID"
                [attachable_id]="ticketID.toString() || ''">
              </app-ticket-attachments>
            }
          </div>
        </div>

        <!-- COMMENTS TAB CONTENT -->
        @if (ticketID) {
          <div comments-tab>
            <div class="tab-content-wrapper">
              <app-ticket-edit-comments [model]="model" [isActiveTab]="activeTabKey === 'comments'"
                (messageAdded)="handleCommentAdded()">
              </app-ticket-edit-comments>
            </div>
          </div>
        }

        <!-- HISTORY TAB CONTENT -->
        @if (ticketID) {
          <div history-tab>
            <app-ticket-history-tab [historyData]="ticketHistory" [ticketId]="ticketID.toString()" [ticketModel]="model"
              (historyChange)="ticketHistory = $event">
            </app-ticket-history-tab>
          </div>
        }
      </app-ticket-main-content>
    </div>
  </div>

  <!-- FOOTER -->
  <div class="ticket-footer">
    <!-- Left Section: Quick Actions -->
    <div class="footer-left">
      <button type="button" mat-button class="footer-action-btn" (click)="toggleFavorite()"
        [attr.aria-label]="isFavorite ? 'Remove from favorites' : 'Add to favorites'"
        [matTooltip]="isFavorite ? 'Remove from favorites' : 'Add to favorites'">
        <mat-icon>{{ isFavorite ? 'star' : 'star_border' }}</mat-icon>
        <span class="btn-text">Add to Favorites</span>
      </button>

      <span class="footer-separator">|</span>

      <button type="button" mat-button class="footer-action-btn" (click)="setReminder()"
        [attr.aria-label]="'Set reminder'" matTooltip="Set reminder">
        <mat-icon>notifications_none</mat-icon>
        <span class="btn-text">Set Reminder</span>
      </button>

      <!-- Save as Template (New Ticket Only) -->
      @if (!ticketID) {
        <div class="save-template-wrapper">
          <span class="footer-separator">|</span>
          <mat-slide-toggle formControlName="is_template" class="save-template-toggle">
            Save as Template
          </mat-slide-toggle>
        </div>
      }
    </div>

    <!-- Right Section: Primary Actions -->
    <div class="footer-right">
      <!-- Cancel Button -->
      <button type="button" mat-stroked-button class="footer-cancel-btn" (click)="close()" [attr.aria-label]="'Cancel'">
        <span class="btn-text">Cancel</span>
      </button>

      <!-- Save Button -->
      <button type="button" mat-raised-button class="footer-save-btn" (click)="save()"
        [disabled]="isSaving" [attr.aria-label]="ticketID ? 'Update ticket' : 'Save ticket'">
        @if (!isSaving) {
          <mat-icon>save</mat-icon>
        }
        @if (isSaving) {
          <mat-spinner diameter="20" class="btn-spinner"></mat-spinner>
        }
        <span class="btn-text">{{ isSaving ? 'Saving...' : (ticketID ? 'Update Ticket' : 'Save Ticket') }}</span>
      </button>
    </div>
  </div>
</div>